import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpRequest } from '@angular/common/http';
import { LOCALE_ID, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { RouteReuseStrategy } from '@angular/router';


// Ionic Modules
import { IonicRouteStrategy } from '@ionic/angular';


// Environment Variables
import { environment as env } from '../../environments/environment';


// Nebular Security
import { NbRoleProvider, NbSecurityModule } from '@nebular/security';


// Nebular Authentication
import {
  NB_AUTH_TOKEN_INTERCEPTOR_FILTER,
  NbAuthJWTToken,
  NbAuthModule,
  NbPasswordAuthStrategy
} from '@nebular/auth';


// Localization
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
registerLocaleData(localeDe, localeDeExtra);


// Providers
import {
  // Guads
  AuthGuard,
  COMON_WEB_API,
  HTTP_API_URL,
  // Injection Tokens
  HTTP_PRESENTAION_URL,
  IntroGuard,
  // Interceptors
  NgAuthJWTInterceptor,
  NOTIFICATION_APP_ID,
  NOTIFICATION_GOOGLE_PROJECTNO,
  // Services
  RoleService,
  throwIfAlreadyLoaded
} from 'projects/business/src/public-api';

const GUARDS = [
    AuthGuard,
    IntroGuard,
];

export const NB_CORE_PROVIDERS = [
    ...NbAuthModule.forRoot({
        strategies: [
            NbPasswordAuthStrategy.setup({
                name: 'email',
                baseEndpoint: env.wp.url + env.wp.api,
                login: {
                    endpoint: env.wp.auth + '/token',
                    method: 'post',
                },
                logout: {
                    method: null,
                    endpoint: '',
                    redirect: {
                        success: '/auth/login',
                        failure: '/pages/dashboard'
                    },
                    alwaysFail: false,
                    requireValidToken: true
                },
                refreshToken: {
                    alwaysFail: false,
                    requireValidToken: true,
                    method: 'post',
                    endpoint: env.wp.auth + '/token/refresh',
                },
                token: {
                    class: NbAuthJWTToken,
                    key: 'token'
                },
                errors: {
                    getter: (module, res, options) => res.error ? res.error.message : options[module].defaultErrors
                }
            })
        ]
    }).providers,

    NbSecurityModule.forRoot({
        accessControl: {
            guest: {},
            subscriber: {
                parent: 'guest',
                view: '*',
            },
            author: {
                parent: 'subscriber',
                create: 'postType'
            },
            editor: {
                parent: 'author'
            },
            administrator: {
                parent: 'editor',
                remove: '*',
            },
        },
    }).providers,

    { provide: NbRoleProvider, useClass: RoleService },
    { provide: LOCALE_ID, useValue: 'de' },
    { provide: HTTP_INTERCEPTORS, useClass: NgAuthJWTInterceptor, multi: true },
    { provide: NB_AUTH_TOKEN_INTERCEPTOR_FILTER, useValue: ((req: HttpRequest<any>) =>
      req.url === `${env.wp.url}${env.wp.api}${env.wp.auth}/token/refresh`)
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: HTTP_PRESENTAION_URL, useValue: env.wp.url },
    { provide: HTTP_API_URL, useValue: env.wp.url },
    { provide: NOTIFICATION_APP_ID, useValue: env.notifications.appId },
    { provide: NOTIFICATION_GOOGLE_PROJECTNO, useValue: env.notifications.googleProjectNumber },
    { provide: COMON_WEB_API, useValue: env.comon.url }
];

@NgModule({
    imports: [CommonModule],
    exports: [NbAuthModule],
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }

    static forRoot(): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule,
            providers: [
                ...NB_CORE_PROVIDERS,
                ...GUARDS,
            ],
        } as ModuleWithProviders<CoreModule>;
    }
}
